import { loadCalendarEntry } from '@/utils/calendarLoader'

export default defineNuxtPlugin((nuxtApp) => {
  // Preload calendar entry on client init
  loadCalendarEntry().catch((e) => {
    console.error('日历模块预加载失败', e)
  })
})
